<template>
	<div id="app" class="pllenty-default">
		<Form :formName="formName" :testMode="testMode" />
	</div>
</template>

<script>
import Form from "./views/Form.vue";

export default {
	name: "App",
	data() {
		return {};
	},
	components: {
		Form,
	},
	props: {
		formName: {
			type: String,
		},
		testMode: {
			type: Boolean,
		},
	},
};
</script>

<style lang="scss">
// html,
// body,
// div,
// span,
// h1,
// h2,
// h3,
// h4,
// h5,
// h6,
// p,
// a,
// em,
// img,
// strong,
// b,
// u,
// i,
// center,
// ol,
// ul,
// li {
// 	font-size: initial !important;
// 	line-height: 1.3em !important;
// 	text-transform: revert !important;
// }

// label {
// 	margin: 0;
// }

// a {
// 	border: none !important;
// 	display: flex !important;
// }

// a:hover {
// 	border: none !important;
// }

body {
	line-height: 22px !important;
}

button {
	min-width: initial !important;
}

input {
	border-color: #ced4da !important;
	border-radius: 6px !important;
}

#app {
	font-family: Lato, Helvetica Neue, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}

.pllenty-default {
	font-size: 16px !important;
}

.pllenty-default h1 {
	font-size: 1.8em !important;
}

.pllenty-default h2 {
	font-size: 1.6em !important;
}

.pllenty-default h3 {
	font-size: 1.4em !important;
}

.pllenty-default h4 {
	font-size: 1.2em !important;
}
</style>
